import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ClipboardIcon from "../../../../../../components/ClipboardIcon/index";
import HelpTip from "../../../../../../components/HelpTip";
import PreviousCards from "../PreviousCards";
import AuthService from '../../../../../../services/AuthService';
import WarningTip from '../../../../../../components/HelpTip/warningTip';

export default class Promotion extends React.Component {

    _onPressResend = (event) => {
        event.preventDefault();
        this.props.onPressResend(this.props.promotion);
    };

    _onPressGenerate = (event) => {
        event.preventDefault();
        const promotion = this.props.promotion;
        if (sessionStorage.getItem('site') != promotion.origin) {
            let msg = `Member belongs to ${promotion.origin} portal. Do you still want to generate the voucher?`;
            if (window.confirm(msg)) {
                this.props.onPressGenerate(this.props.promotion.name, this.props.promotion.shouldUnsubscribe, this.props.promotion.wasSubscribed);
            }
        } else {
            this.props.onPressGenerate(this.props.promotion.name, this.props.promotion.shouldUnsubscribe, this.props.promotion.wasSubscribed);
        }
    };

    render() {
        const promotion = this.props.promotion;
        let dotClass = 'btn--lime';
        let expiryDate = '-';
        let balance_default = '';
        let balance_other = '';
        let currency_default = '';
        let currency_other = '';
        if (promotion.giftcard !== null) {


            console.log(promotion.giftcard.currency);
            if (promotion.giftcard.balance != null) {
                balance_default = promotion.giftcard.balance.split("|")[0];
                balance_other = promotion.giftcard.balance.split("|")[1];
            }

            if (promotion.giftcard.balance != null) {
                currency_default = promotion.giftcard.currency.split("|")[0];
                currency_other = promotion.giftcard.currency.split("|")[1];
            }

            if ($.inArray(promotion.giftcard.status, ['Redeemed', 'On Hold', 'Not Activated']) > -1) {
                dotClass = 'btn--yellow';
            }
            else if (promotion.giftcard.status === 'Expired') {
                dotClass = 'btn--red';
            }
            if (promotion.giftcard.expiryDate !== null) {
                expiryDate = moment(promotion.giftcard.expiryDate).format('D MMMM YYYY');
            }
        }
        return (
            <li>
                <div className="clearfix margin--20--bot">
                    <h4 className="text--18 f-left"><strong>{promotion.name}&nbsp;</strong></h4>
                    {promotion.giftcard !== null &&
                        <span className={'f-right btn btn--tiny ' + dotClass}>{promotion.giftcard.status}</span>
                    }
                </div>
                {this.props.children}
                
                {AuthService.can('generate promotion voucher') && promotion.giftcard == null && promotion.canGenerate &&
                    <React.Fragment>
                        <button className="btn btn--small btn--color margin--20--right" onClick={this._onPressGenerate}>Generate</button>
                        {sessionStorage.getItem('site') != promotion.origin &&
                            <WarningTip><span>Member belongs to {promotion.origin} portal.</span></WarningTip>
                        }
                    </React.Fragment>
                }
                {promotion.giftcard !== null &&
                    <div>
                        <p className="list--info__label text--break">
                            <strong className="text--caps text--color margin--10--right">Card number&nbsp;</strong>
                            <span className="margin--20--right">{promotion.giftcard.cardNumber}</span>
                            <ClipboardIcon text={promotion.giftcard.cardNumber} />
                        </p>
                        <p className="list--info__label">
                            <strong className="text--caps text--color">Balance&nbsp;</strong>
                            {(currency_default || '').trim() != (currency_other || '').trim() && <React.Fragment>
                                {currency_default} {balance_default} &nbsp;&nbsp; {currency_other} {balance_other}
                            </React.Fragment>}
                            {(currency_default || '').trim() == (currency_other || '').trim() && <React.Fragment>
                                {currency_default} {balance_default}
                            </React.Fragment>}
                            {promotion.giftcard.preAuthBalance !== '0.00' &&
                                <span className="preauth text--15"><br />+${promotion.giftcard.preAuthBalance} Pre-Authed</span>
                            }
                        </p>
                        <p className="list--info__label">
                            <strong className="text--caps text--color">Expiry date&nbsp;</strong>
                            {expiryDate}
                        </p>
                        {promotion.lastResend && <p className="list--info__label">
                            <strong className="text--caps text--color">Resent Date&nbsp;</strong>
                            {promotion.lastResend.summary}
                        </p>}
                        {/* {promotion.canResend && */}
                        {promotion.canResend && AuthService.can('Resend promotion voucher') &&
                            <button className="btn btn--small btn--color margin--20--right" onClick={this._onPressResend}>Resend</button>
                        }
                        {/* {(AuthService.isAdmin() || AuthService.getAdminType() == 3) && promotion.canGenerate && */}
                        {AuthService.can('Generate promotion voucher') && promotion.canGenerate &&
                            <React.Fragment>
                                <button className="btn btn--small btn--color margin--20--right" onClick={this._onPressGenerate}>Generate</button>
                                {sessionStorage.getItem('site') != promotion.origin &&
                                    <WarningTip>Member belongs to {promotion.origin} Portal.</WarningTip>
                                }
                            </React.Fragment>
                        }
                        {/* {!promotion.canResend && !promotion.canGenerate && */}
                        {!promotion.canResend && !promotion.canGenerate && AuthService.can('Resend promotion voucher') &&
                            <button className="btn btn--small btn--color margin--20--right" disabled="disabled">Resend</button>
                        }
                        {/* {!promotion.canResend && !promotion.canGenerate && */}
                        {!promotion.canResend && !promotion.canGenerate && AuthService.can('Resend promotion voucher') &&
                            <HelpTip><span>Member must subscribe to newsletter to receive emails.</span></HelpTip>
                        }
                    </div>
                }
            </li>
        )
    }
}

Promotion.propTypes = {
    promotion: PropTypes.object.isRequired,
    onPressResend: PropTypes.func.isRequired,
};
